export const WATCHLIST_ENABLED = false;
